export interface Episode {
  ep: string;
  title: string;
  date: string;
  tag: '新' | '热' | '沸';
  summary: string;
  points: string[];
}

export interface Series {
  id: string;
  title: string;
  categoryKey: string;
  categoryName: string;
  status: 'ongoing' | 'finished' | 'coming';
  tags: string[];
  heat: number;
  updated: string;
  latestEp: string;
  totalEps: string;
  summary: string;
  cover: string;
  episodes: Episode[];
}

export const categoryMap = [
  { key: 'yanxiu', name: '竞演选秀', icon: 'ri-mic-2-line', desc: '成团、晋级、淘汰，舞台上的戏剧从不落幕' },
  { key: 'love', name: '恋爱情感', icon: 'ri-heart-3-line', desc: '心动信号与关系反转，追到底才过瘾' },
  { key: 'film', name: '影视幕后', icon: 'ri-clapperboard-line', desc: '选角、换角、拍摄现场的暗流涌动' },
  { key: 'biz', name: '商业瓜局', icon: 'ri-line-chart-line', desc: '代言、解约、资本博弈，一场场生意场大戏' },
  { key: 'music', name: '音乐风云', icon: 'ri-music-2-line', desc: '发歌、对撕、版权之争的连续剧情' },
  { key: 'sports', name: '体娱热点', icon: 'ri-trophy-line', desc: '赛场外的舆情与人物故事同样精彩' },
];

export const seriesList: Series[] = [
  {
    id: 'jiu-meng',
    title: '旧梦少年·成团夜倒计时',
    categoryKey: 'yanxiu',
    categoryName: '竞演选秀',
    status: 'ongoing',
    tags: ['成团夜', '重组', '老粉回流'],
    heat: 968,
    updated: '09-07',
    latestEp: '第9集',
    totalEps: '已更9/14',
    summary: '出道五年的男团旧梦少年突然宣布年底解散重组，七位成员的合约、站位与去留成了饭圈最热的追更连续剧。',
    cover: 'https://readdy.ai/api/search-image?query=Flat%20modern%20editorial%20illustration%20of%20a%20concert%20stage%20with%20seven%20silhouetted%20idol%20figures%20under%20spotlights%20and%20confetti%2C%20warm%20cream%20background%2C%20coral%20orange%20red%20and%20mint%20green%20watermelon%20palette%2C%20soft%20rounded%20shapes%2C%20minimal%2C%20high%20detail&width=800&height=500&seq=cover-jiu-meng&orientation=landscape',
    episodes: [
      { ep: '第1集', title: '解散公告连夜发出', date: '08-10', tag: '热', summary: '凌晨一点，经纪公司官网挂出重组公告，评论区瞬间涌进三万条留言。', points: ['公告称"为成员个人发展考虑"', '七人站位图被扒出端倪', '官博精选评论翻车'] },
      { ep: '第3集', title: 'C位之争暗流涌动', date: '08-22', tag: '沸', summary: '重组后站位排序流出版，多年主C被换到角落，粉丝炸锅。', points: ['疑似内部会议录音流出', '队长直播回应模棱两可', '两派粉丝站队开战'] },
      { ep: '第6集', title: '前队友爆料练习室真相', date: '09-01', tag: '热', summary: '已离队成员直播聊起当年分工，矛头直指核心制作人偏心。', points: ['直播切片全网疯传', '原视频当晚被删引猜疑', '公司回应"系剪辑误导"'] },
      { ep: '第9集', title: '成团夜名单提前泄出', date: '09-07', tag: '沸', summary: '疑似最终五人成团名单提前流出，留在原地的人另有安排。', points: ['票务平台现退票潮', '两人被拍到连夜搬家', '距离成团夜仅剩3天'] },
    ],
  },
  {
    id: 'yan-yu',
    title: '烟雨CP·世纪同台',
    categoryKey: 'love',
    categoryName: '恋爱情感',
    status: 'ongoing',
    tags: ['世纪同台', '复合疑云', '综艺营业'],
    heat: 901,
    updated: '09-06',
    latestEp: '第7集',
    totalEps: '已更7/10',
    summary: '三年前官宣分手的荧幕情侣，在一档观察类综艺里被重新安排坐在一起，破镜能否重圆牵动无数"破镜重圆党"。',
    cover: 'https://readdy.ai/api/search-image?query=Flat%20modern%20editorial%20illustration%20of%20two%20reunion%20couple%20silhouettes%20sitting%20under%20a%20heart%20shaped%20sunset%20on%20a%20talk%20show%20sofa%2C%20warm%20cream%20background%2C%20coral%20orange%20red%20and%20mint%20green%20watermelon%20palette%2C%20soft%20rounded%20shapes%2C%20minimal%2C%20high%20detail&width=800&height=500&seq=cover-yan-yu&orientation=landscape',
    episodes: [
      { ep: '第1集', title: '观察团官宣嘉宾名单', date: '08-12', tag: '热', summary: '节目先导片最后一秒，前情侣同框的镜头炸上热搜。', points: ['先导片播放量破纪录', '两人分坐两端全场无交流', '主持人抛出"前任话题"'] },
      { ep: '第4集', title: '旧照被扒：分居真相', date: '08-28', tag: '沸', summary: '网友从三年旧照里找到端倪，当年的分手声明或有隐情。', points: ['照片水印时间对不上', '共同好友账号关注了对方', '女方友人小号点赞引联想'] },
      { ep: '第7集', title: '同台对视12秒名场面', date: '09-06', tag: '沸', summary: '最新一期两人被安排合作环节，对视瞬间全场安静，热搜词条爆了。', points: ['正片镜头被逐帧分析', '女方眼眶泛红引发心疼', '导演组连夜加班剪花絮'] },
    ],
  },
  {
    id: 'yuan-zou',
    title: '选角疑云·女主换人始末',
    categoryKey: 'film',
    categoryName: '影视幕后',
    status: 'ongoing',
    tags: ['临开拍换角', '潜规则疑云', '剧组内幕'],
    heat: 843,
    updated: '09-05',
    latestEp: '第5集',
    totalEps: '已更5/12',
    summary: '古装大剧开机前十天突然换掉官宣女主，原定演员退组后连发三条意味深长的动态，剧组选角的内幕被一点点揭开。',
    cover: 'https://readdy.ai/api/search-image?query=Flat%20modern%20editorial%20illustration%20of%20a%20movie%20clapperboard%20and%20film%20reel%20with%20a%20question%20mark%20and%20audition%20door%2C%20warm%20cream%20background%2C%20coral%20orange%20red%20and%20mint%20green%20watermelon%20palette%2C%20soft%20rounded%20shapes%2C%20minimal%2C%20high%20detail&width=800&height=500&seq=cover-yuan-zou&orientation=landscape',
    episodes: [
      { ep: '第1集', title: '开机前十天换掉女主', date: '08-15', tag: '沸', summary: '剧组突然官宣换角，原定女主通稿已铺满全平台。', points: ['原女主粉丝维权热搜', '通稿一夜之间全删', '新女主曾被质疑空降'] },
      { ep: '第2集', title: '"莫须有"三字回应', date: '08-19', tag: '热', summary: '原定女主演深夜发文，用"莫须有"三字疑似回应解约原因。', points: ['配图是空白剧本', '评论数十分钟破万', '经纪公司转发称"共同决定"'] },
      { ep: '第5集', title: '副导演匿名开麦', date: '09-05', tag: '热', summary: '自称剧组副导演的账号爆料选角流程，称换人是"上头安排"。', points: ['爆料时间线与通稿吻合', '对方拒绝对质', '剧组称将保留追责权利'] },
    ],
  },
  {
    id: 'pai-ming',
    title: '代言风云·国民饮料换帅',
    categoryKey: 'biz',
    categoryName: '商业瓜局',
    status: 'ongoing',
    tags: ['代言换人', '违约金', '品牌方下场'],
    heat: 776,
    updated: '09-04',
    latestEp: '第4集',
    totalEps: '已更4/6',
    summary: '代言三年的国民饮料突然官宣新代言人，旧代言人解约背后是天价违约金，还是一场借势营销？生意场的大戏同样精彩。',
    cover: 'https://readdy.ai/api/search-image?query=Flat%20modern%20editorial%20illustration%20of%20a%20beverage%20bottle%20exchange%20with%20contract%20papers%20and%20coins%20and%20megaphone%2C%20warm%20cream%20background%2C%20coral%20orange%20red%20and%20mint%20green%20watermelon%20palette%2C%20soft%20rounded%20shapes%2C%20minimal%2C%20high%20detail&width=800&height=500&seq=cover-pai-ming&orientation=landscape',
    episodes: [
      { ep: '第1集', title: '三年代言一夜官宣更替', date: '08-20', tag: '热', summary: '国民饮料官宣新代言人，旧代言人的海报连夜被撤下。', points: ['线下门店物料同步更换', '旧代言人被曝"零预警"', '网友盘点历任代言翻车史'] },
      { ep: '第3集', title: '违约金数字疯传', date: '09-01', tag: '沸', summary: '业内流传解约违约金高达八位数，双方对具体数字讳莫如深。', points: ['知情人士爆"确有条款"', '品牌方声明"友好解约"', '公关稿前后措辞矛盾'] },
      { ep: '第4集', title: '旧代言人评论区沦陷', date: '09-04', tag: '热', summary: '旧代言人最新动态下涌进大量"还我广告"的玩梗留言，吃瓜群众玩疯了。', points: ['玩梗话题登上趋势榜', '旧代言人回复一个"?"', '品牌方顺势联动搞笑官号'] },
    ],
  },
  {
    id: 'yin-yue',
    title: '音源大战·词曲版权之争',
    categoryKey: 'music',
    categoryName: '音乐风云',
    status: 'ongoing',
    tags: ['抄袭风波', '版权', '公开叫板'],
    heat: 712,
    updated: '09-03',
    latestEp: '第6集',
    totalEps: '已更6/8',
    summary: '两首同期大热歌曲被指旋律高度相似，制作人与歌手隔空喊话，音源大战一触即发，谁在借热度，谁在谈版权？',
    cover: 'https://readdy.ai/api/search-image?query=Flat%20modern%20editorial%20illustration%20of%20two%20music%20notes%20fighting%20over%20a%20sheet%20of%20melody%20with%20headphones%20and%20equalizer%2C%20warm%20cream%20background%2C%20coral%20orange%20red%20and%20mint%20green%20watermelon%20palette%2C%20soft%20rounded%20shapes%2C%20minimal%2C%20high%20detail&width=800&height=500&seq=cover-yin-yue&orientation=landscape',
    episodes: [
      { ep: '第2集', title: '扒谱对比刷屏音乐区', date: '08-24', tag: '热', summary: '音乐博主逐小节扒谱，把两首歌的相似片段并排对比。', points: ['对比视频播放量破千万', '评论区专业乐评吵翻天', '疑似本人小号出现'] },
      { ep: '第5集', title: '制作人深夜发长文', date: '09-02', tag: '沸', summary: '其中一位制作人发长文讲述创作过程，暗指对方"借鉴过度"。', points: ['长文提到"旋律撞车"', '同行制作人纷纷转发站队', '音源平台下架一首引热议'] },
      { ep: '第6集', title: '直播对线全程高能', date: '09-03', tag: '沸', summary: '两位歌手同时开直播隔空回应，一个说"清者自清"，一个晒出创作时间戳。', points: ['同屏弹幕互相攻讦', '直播时长超三小时', '相关话题霸榜整整一天'] },
    ],
  },
  {
    id: 'lei-jing',
    title: '雷竞技·退役声明反转再反转',
    categoryKey: 'sports',
    categoryName: '体娱热点',
    status: 'finished',
    tags: ['退役', '复出', '俱乐部矛盾'],
    heat: 685,
    updated: '09-02',
    latestEp: '第8集',
    totalEps: '已完结8/8',
    summary: '电竞选手"雷荆"从宣布退役到疑似复出，短短两个月来了三次大反转，这条退役声明成了今年最跌宕的连续剧。',
    cover: 'https://readdy.ai/api/search-image?query=Flat%20modern%20editorial%20illustration%20of%20a%20gaming%20champion%20trophy%20and%20gaming%20controller%20with%20a%20reversing%20arrow%20and%20retirement%20sign%2C%20warm%20cream%20background%2C%20coral%20orange%20red%20and%20mint%20green%20watermelon%20palette%2C%20soft%20rounded%20shapes%2C%20minimal%2C%20high%20detail&width=800&height=500&seq=cover-lei-jing&orientation=landscape',
    episodes: [
      { ep: '第1集', title: '官宣退役告别赛场', date: '07-10', tag: '热', summary: '名将"雷荆"深夜发退役长文，感谢粉丝，留下"后会无期"。', points: ['退役微博点赞破两百万', '俱乐部转发祝前程似锦', '粉丝评论区一片告别'] },
      { ep: '第4集', title: '陪练视频疑复出前兆', date: '07-30', tag: '沸', summary: '一段训练室陪练视频流出，画面里的人被指就是"雷荆"。', points: ['身形与操作习惯高度吻合', '俱乐部避而不谈', '本人直播玩梗不否认'] },
      { ep: '第6集', title: '与俱乐部旧怨被扒', date: '08-18', tag: '热', summary: '网友扒出退役前与俱乐部的薪酬纠纷，退役真相存疑。', points: ['合同细节被逐条解读', '前队友直播隐晦证实', '官博账号突然改名'] },
      { ep: '第8集', title: '大结局：以新队名回归', date: '09-02', tag: '沸', summary: '新赛季大名单公布，"雷荆"以队长身份回归，一切尘埃落定。', points: ['回归宣传片燃炸', '旧怨双方握手言和', '系列正式完结'] },
    ],
  },
  {
    id: 'wei-lai',
    title: '新人出道企划·迷雾开始',
    categoryKey: 'yanxiu',
    categoryName: '竞演选秀',
    status: 'coming',
    tags: ['新企划', '神秘导师', '抢先报名'],
    heat: 430,
    updated: '09-07',
    latestEp: '预告',
    totalEps: '待开播',
    summary: '一档号称"不设限出道"的新人企划启动，神秘导师阵容、神秘赛制，一切从零揭开，前情铺垫已经开始。',
    cover: 'https://readdy.ai/api/search-image?query=Flat%20modern%20editorial%20illustration%20of%20a%20mysterious%20dark%20curtain%20stage%20with%20a%20glowing%20question%20mark%20spotlight%20and%20rising%20young%20singer%20silhouette%2C%20warm%20cream%20background%2C%20coral%20orange%20red%20and%20mint%20green%20watermelon%20palette%2C%20soft%20rounded%20shapes%2C%20minimal%2C%20high%20detail&width=800&height=500&seq=cover-wei-lai&orientation=landscape',
    episodes: [
      { ep: '预告', title: '神秘企划海报上线', date: '09-07', tag: '新', summary: '企划官号深夜放出一张迷雾海报，配文"这一次，重新定义出道"。', points: ['海报暗藏六位数字', '评论区玩起解谜', '关注数一夜暴涨'] },
    ],
  },
  {
    id: 'fang-xin',
    title: '晚风系列·邻里综艺售后',
    categoryKey: 'film',
    categoryName: '影视幕后',
    status: 'finished',
    tags: ['综艺售后', '番外', '团综'],
    heat: 590,
    updated: '08-30',
    latestEp: '第6集',
    totalEps: '已完结6/6',
    summary: '口碑综艺《晚风小院》收官后的团综售后，五位常驻嘉宾的乡村旅居生活，也被观众当成了下饭连续剧追。',
    cover: 'https://readdy.ai/api/search-image?query=Flat%20modern%20editorial%20illustration%20of%20a%20cozy%20small%20courtyard%20house%20with%20friends%20around%20a%20cooking%20pot%20and%20teacups%20and%20evening%20sunlight%2C%20warm%20cream%20background%2C%20coral%20orange%20red%20and%20mint%20green%20watermelon%20palette%2C%20soft%20rounded%20shapes%2C%20minimal%2C%20high%20detail&width=800&height=500&seq=cover-fang-xin&orientation=landscape',
    episodes: [
      { ep: '第2集', title: '五人重聚小院营业', date: '08-12', tag: '热', summary: '收官一个月后，五位常驻突然重聚老院，团综企划官宣。', points: ['首播弹幕刷屏', '嘉宾互动被称"活人感"', '观看量登顶生活类'] },
      { ep: '第6集', title: '收官大联欢·圆满落幕', date: '08-30', tag: '热', summary: '以一场篝火晚宴收尾，全员落泪，观众直呼"舍不得"。', points: ['名场面不断', '原班人马留悬念', '评论区一片呼唤第二季'] },
    ],
  },
];

export const testimonialList = [
  { name: '一颗枣', role: '追更老粉', text: '以前吃瓜吃到一半老是断片，现在有吃瓜每日的集数整理，剧情脉络清清楚楚，追更体验真的像看连续剧。', avatar: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20avatar%20illustration%20of%20a%20friendly%20young%20woman%20with%20bob%20hair%2C%20coral%20orange%20and%20mint%20green%20watermelon%20palette%2C%20warm%20cream%20background%2C%20soft%20rounded%2C%20high%20detail&width=300&height=300&seq=av-1&orientation=squarish' },
  { name: '路过的瓜农', role: '连续追更第12天', text: '第N集这个概念太戳我了，每天定时来看有没有更新，停更的时候还会在评论区一起蹲后续，很有追剧那味儿。', avatar: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20avatar%20illustration%20of%20a%20friendly%20young%20man%20with%20short%20hair%20and%20glasses%2C%20coral%20orange%20and%20mint%20green%20watermelon%20palette%2C%20warm%20cream%20background%2C%20soft%20rounded%2C%20high%20detail&width=300&height=300&seq=av-2&orientation=squarish' },
  { name: '阿满', role: '类型控', text: '按类型分好类真的很省心，想看恋综售后就去恋爱情感，想追选秀就去竞演选秀，类型导航清晰不迷路。', avatar: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20avatar%20illustration%20of%20a%20young%20woman%20with%20long%20hair%20wearing%20a%20headband%2C%20coral%20orange%20and%20mint%20green%20watermelon%20palette%2C%20warm%20cream%20background%2C%20soft%20rounded%2C%20high%20detail&width=300&height=300&seq=av-3&orientation=squarish' },
];